import { Button, Card, EmptyState } from '../../components/ui';
import { formatHora } from '../../utils/fechas';
import { nombreSede } from './BuscarUtils';
import './Buscar.css';

export default function ListaTurnosDisponibles({ turnos, onElegir }) {
  if (turnos.length === 0) {
    return <EmptyState title="No quedan turnos disponibles para esta fecha." />;
  }

  return (
    <div className="buscar-list" role="list">
      {turnos.map((t) => (
        <Card key={t.id} role="listitem">
          <div className="buscar-turno-row">
            <div>
              <div className="buscar-turno-hora">{formatHora(t.fechaYHora)}</div>
              <p className="buscar-muted" style={{ margin: '4px 0 0' }}>
                {nombreSede(t.sede)} · {t.medico?.nombre} · {t.servicio?.nombre}
              </p>
            </div>
            <Button onClick={() => onElegir(t)}>Reservar</Button>
          </div>
        </Card>
      ))}
    </div>
  );
}